// CSS
import './ResultIndexCounterOverlay.css';
// React hooks
import { useState } from 'react';
import ReactDOM from "react-dom";   // for React Portals
// Skybase hooks
import { useQuery } from '../../../../context/QueryContext';


// top-level HTML element to display this Overlay within (above all other page content)
const modalRoot = document.getElementById("modal-root")



// =========================
// ResultIndexCounterOverlay – represents the '/results' Product page index counter overlay (used by CurrentUser to understand which results they've viewed)
// =========================
function ResultIndexCounterOverlay({
    openedEntityIndex,      // int          – the index of the currently-opened Entity
    viewedResults,          // String[]     – a UUID[] of all the already-viewed Document results
    onChipClickCallback,    // ()           – the Callback Function triggered by a Chip Click
}) {
    // destructure global context
    const { rankedQueryResults } = useQuery();

    // ============================================
    // handleIndexCounterInstanceClick(uuid: String) – triggers the onChipClickCallback()
    // ============================================
    const handleIndexCounterInstanceClick = (uuid) => {
        
        // trigger callback
        onChipClickCallback(uuid);
    }


    // JSX Component – React Portal
    return ReactDOM.createPortal(
        <div className='ResultsPage-index-counter-overlay'>
                
                {/* Repeater */}
                { rankedQueryResults.map( (result_json, index) => (
                    <div
                        key={result_json.id}
                        className='ResultsPage-index-counter-overlay--instance-content'
                        onClick={() => handleIndexCounterInstanceClick(result_json.id)}
                        style={{ "--stagger-index": Math.min(0, index) }}
                        >
                        <div className={`ResultsPage-index-counter-overlay--instance ${viewedResults.includes(result_json.id) ? 'viewed' : ''} ${openedEntityIndex === index ? 'current' : ''}`}>
                        </div>
                    </div>
                )) }
                
            </div>
    ,modalRoot);
};


// Export statement
export default ResultIndexCounterOverlay;